export const sidebarButtonText = [
  'Create Tasks',
  'Marking Templates',
  'Comment banks',
  'Self-Assessment',
  'Give Feedback',
  'Use AI',
  'Share Exemplars',
  'View Class Insights',
];

export const mainSectionContent = [
  {
    id: 0,
    title: 'Create Tasks',
    subTitle:
      "Click the 'New Task' button in the top right corner to create, customise and assign a writing task for your classes.",
    video: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    id: 1,
    title: 'Add Marking Templates',
    subTitle:
      'Use a preloaded template or create your own criteria to provide overall feedback with rubrics.',
    video: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    id: 2,
    title: 'Comment Banks',
    subTitle:
      'Create your own comment banks to speed up the marking process, or edit our preloaded comment banks in the Marking Tools section.',
    video: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    id: 3,
    title: 'Self-Assessment',
    subTitle:
      'Get students to highlight key elements in their work before they submit for feedback.',
    video: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    id: 4,
    title: 'Give Feedback',
    subTitle:
      'Provide timely and practical feedback to students by using personalised AI suggestions, comment banks and rubrics.',
    video: 'https://fast.wistia.net/embed/iframe/vj1ioj8188',
  },
  {
    id: 5,
    title: 'Use AI',
    subTitle:
      "Use our teacher-trained AI model to produce instant feedback on a student submission. You can edit JeddAI's suggestions before submitting feedback to students.",
    video: 'https://fast.wistia.net/embed/iframe/vj1ioj8188',
  },
  {
    id: 6,
    title: 'Share Exemplars',
    subTitle:
      'Help students learn from each other by sharing work in your class library.',
    video: 'https://fast.wistia.net/embed/iframe/vj1ioj8188',
  },
  {
    id: 7,
    title: 'View Class Insights',
    subTitle:
      'Identify skill gaps with real-time insights based on the most common areas of feedback.',
    video: 'https://fast.wistia.net/embed/iframe/5syf3fudi1',
  },
];

export const welcomeOnboardingPages = [
  {
    name: 'Task',
    link: '/tasks/new',
    icon: '/img/taskIcon.svg',
  },
  {
    name: 'JeddAI Draft',
    link: '/getFeedback',
    icon: '/img/jedaiIcon.svg',
  },
  {
    name: 'Marking Template',
    link: '/tools/rubrics/new',
    icon: '/img/rubrics2.svg',
  },
  {
    name: 'Comment Bank',
    link: '/tools/commentbanks?createNew=true',
    icon: '/img/commentbankIcon.svg',
  },
];

export const whatIsJeddAiFaq = [
  {
    title: 'Why am I here? ',
    content:
      "Great news! Your school has partnered with Jeddle, which means that you and your students now have access to its curriculum-specific English text guides and writing modules, as well as its game-changing feedback and marking tools. Because you have just clicked on 'JeddAI', you are currently on the feedback...",
  },
  {
    title: 'What is JeddAI and how will it help me and my students?  ',
    content:
      "Great news! Your school has partnered with Jeddle, which means that you and your students now have access to its curriculum-specific English text guides and writing modules, as well as its game-changing feedback and marking tools. Because you have just clicked on 'JeddAI', you are currently on the feedback...",
  },
  {
    title: 'How do I set up my classes?  ',
    content:
      "Great news! Your school has partnered with Jeddle, which means that you and your students now have access to its curriculum-specific English text guides and writing modules, as well as its game-changing feedback and marking tools. Because you have just clicked on 'JeddAI', you are currently on the feedback...Great news! Your school has partnered with Jeddle, which means that you and your students now have access to its curriculum-specific English text guides and writing modules, as well as its game-changing feedback and marking tools. Because you have just clicked on 'JeddAI', you are currently on the feedback...Great news! Your school has partnered with Jeddle, which means that you and your students now have access to its curriculum-specific English text guides and writing modules, as well as its game-changing feedback and marking tools. Because you have just clicked on 'JeddAI', you are currently on the feedback...",
  },
];

export const videoLinks = [
  {
    image: '/img/createTask.svg',
    link: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    image: '/img/howtoaddmarking.svg',
    link: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    image: '/img/howtoaddcommentbank.svg',
    link: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    image: '/img/selftassesment.svg',
    link: 'https://fast.wistia.net/embed/iframe/pxkf4ankwt',
  },
  {
    image: '/img/givefeedback.svg',
    link: 'https://fast.wistia.net/embed/iframe/vj1ioj8188',
  },
  {
    image: '/img/aiassistedmarking.svg',
    link: 'https://fast.wistia.net/embed/iframe/vj1ioj8188',
  },
  {
    image: '/img/shareexemplar.svg',
    link: 'https://fast.wistia.net/embed/iframe/vj1ioj8188',
  },

  {
    image: '/img/howToClass.svg',
    link: 'https://fast.wistia.net/embed/iframe/5syf3fudi1',
  },
];
